import { useMachine } from "@xstate/react";
import { Popup } from "devextreme-react";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { Machine } from "xstate";
import { api } from "../../../request/api";
import { AuthenticationResponse } from "../../../Types/AuthenticationResponse";
import { saveAuthentication } from "../../../_helpers/token";
import { InputEx } from "../../Inputs/InputEx";
import { InputLabel } from "../../Labels/InputLabel";
import notify from "devextreme/ui/notify";
import { LoadPanelFullScreen } from "../../LoadPanel/LoadPanelFullScreen";


type Props = {
  login?: string;
};

const fetchMachine = Machine({
  id: "loginForm",
  initial: "idle",
  states: {
    idle: {
      on: {
        FETCH: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      entry: "sigin",
    },
    failure: {
      on: {
        FETCH: "loading",
      },
    },
  },
});

interface IFormInputs {
  login: string;
}

const ForgetPasswordForm: React.FC<Props> = (login) => {
  const history = useHistory();
  const { register, getValues, handleSubmit, errors } = useForm<IFormInputs>();
  const [loading, setLoading] = useState<boolean>(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [state, send] = useMachine(fetchMachine, {
    actions: {
      sigin: () => {
        history.push("/");
      },
    },
  });

  const onSubmit = async (formData: IFormInputs) => {
    send("FETCH");
    setLoading(true);
    try {
      await api
        .post<Response>("User/ForgetPassword", {
          Login: formData.login,
        })
        .then((response) => {
          notify(response.data, "success", 10000);
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
      send("REJECT");
      notify("Błąd", "error", 5000);
    }
  };

  return (
    <>
      <LoadPanelFullScreen visible={loading} />
      <div className="changePasswordForm">
        <div className="cpWrap">
          <div className="mainTitle">Zmiana / Nadanie hasła</div>

          <form onSubmit={handleSubmit(onSubmit)} className="align-self-center">

            <div className="form-group">
              <InputLabel forHtml="login" message="Login" />
              <InputEx
                className="form-control"
                placeholder="login"
                name="login"
                inputRef={register()}
              />
            </div>

            <InputEx
              type="submit"
              className="btn btnSuccess mt-5"
              value="Wyślij "
            />
          </form>
        </div>
      </div>
    </>
  );
};

export { ForgetPasswordForm };
